module.exports = __webpack_public_path__ + "static/media/chevron-down-white.fb0156af.svg";